import { render, staticRenderFns } from "./Center.vue?vue&type=template&id=61824329"
import script from "./Center.vue?vue&type=script&lang=js"
export * from "./Center.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports